import(/* webpackMode: "eager", webpackExports: ["NewsCardsList"] */ "/vercel/path0/components/news/NewsCardsList/NewsCardsList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/pages/newsDetails/NewsDetailsPage.preview.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/shared/SharedLinks/SharedLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Video"] */ "/vercel/path0/components/shared/Video/Video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["YoutubeVideo"] */ "/vercel/path0/components/shared/YoutubeVideo/YoutubeVideo.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/VisualEditing.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
